import React, { useState } from 'react';
import api from '../api';
import DatenschutzCheckbox from './DatenschutzCheckbox';
import Erfolgsmeldung from './Erfolgsmeldung';
import FormularFelder, { useKachelFormular, validiereFelder, trenneWerte } from './FormularFelder';

export default function ProbetrainingFormular() {
  const { laden, fehler: ladeFehler, kachel } = useKachelFormular('probetraining');
  const felder = kachel?.formular_felder || [];

  const [werte, setWerte] = useState({});
  const [datenschutz, setDatenschutz] = useState(false);
  const [website, setWebsite] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState('');
  const [success, setSuccess] = useState(false);

  const setzeWert = (id, wert) => {
    setWerte(prev => ({ ...prev, [id]: wert }));
    if (errors[id]) setErrors(prev => ({ ...prev, [id]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validiereFelder(felder, werte);
    if (!datenschutz) errs.datenschutz_akzeptiert = 'Datenschutz muss akzeptiert werden';
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setLoading(true);
    setServerError('');
    try {
      const { system, zusatz } = trenneWerte(felder, werte);
      await api.post('/api/probetraining', {
        ...system,
        zusatzfelder: zusatz,
        datenschutz_akzeptiert: 'true',
        website,
      });
      setSuccess(true);
    } catch (err) {
      setServerError(err.response?.data?.error || 'Fehler beim Senden. Bitte versuche es später erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <Erfolgsmeldung
        titel="Anfrage gesendet!"
        text={kachel?.bestaetigung_text || 'Vielen Dank! Wir haben deine Probetraining-Anfrage erhalten und melden uns in Kürze bei dir.'}
      />
    );
  }

  if (laden) return (
    <div className="form-container">
      <div style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>Lädt…</div>
    </div>
  );

  if (ladeFehler || !kachel) return (
    <div className="form-container">
      <h2 className="form-title">Probetraining anfragen</h2>
      <p style={{ color: '#c62828', textAlign: 'center', padding: '2rem' }}>
        Das Formular ist gerade nicht verfügbar. Bitte versuche es später erneut.
      </p>
    </div>
  );

  return (
    <div className="form-container">
      <h2 className="form-title">Probetraining anfragen</h2>
      {serverError && <div className="alert alert-error">{serverError}</div>}

      <form onSubmit={handleSubmit} noValidate>
        <div className="honeypot" aria-hidden="true">
          <input type="text" name="website" value={website} onChange={e => setWebsite(e.target.value)} tabIndex="-1" autoComplete="off" />
        </div>

        <FormularFelder felder={felder} werte={werte} fehler={errors} onChange={setzeWert} />

        <DatenschutzCheckbox
          checked={datenschutz}
          onChange={e => { setDatenschutz(e.target.checked); if (errors.datenschutz_akzeptiert) setErrors(p => ({ ...p, datenschutz_akzeptiert: '' })); }}
          error={errors.datenschutz_akzeptiert}
        />

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Wird gesendet…' : 'Probetraining anfragen'}
        </button>
      </form>
    </div>
  );
}
